import { __extends, __rest, __assign } from 'tslib';
import * as React from 'react';
import { throttle } from 'throttle-debounce';
import { classNames, analyticsTracker } from 'uitk-react-utils';
import { UitkLayoutFlexItem, UitkLayoutFlex } from 'uitk-react-layout-flex';
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import styles from './uitk-toolbar.css';

var ToolbarContainerTagMap = [
    ['div', 'div'],
    ['header', 'header'],
    ['section', 'section']
];
var UitkToolbarContainerTags = new Map(ToolbarContainerTagMap);
var UitkToolbarNavigationTypeIconsMap = [
    ['close', 'close'],
    ['back', 'arrow_back'],
    ['expand_up', 'expand_less']
];
var UitkToolbarNavigationTypeIcons = new Map(UitkToolbarNavigationTypeIconsMap);
var UitkToolbarTitleTagMap = [
    ['h1', 'h1'],
    ['h2', 'h2'],
    ['h3', 'h3'],
    ['h4', 'h4'],
    ['h5', 'h5'],
    ['h6', 'h6']
];
var UitkToolbarTitleTags = new Map(UitkToolbarTitleTagMap);
var UitkToolbarTypesMap = [
    ['standard', 'standard'],
    ['transparent', 'transparent']
];
var UitkToolbarTypes = new Map(UitkToolbarTypesMap);

var getClassNameList$4 = classNames.bind(styles);
// To be cleaned up
var ToolbarHeaderType;
(function (ToolbarHeaderType) {
    ToolbarHeaderType["OVERLAY"] = "Overlay";
})(ToolbarHeaderType || (ToolbarHeaderType = {}));
var Toolbar = /** @class */ (function (_super) {
    __extends(Toolbar, _super);
    function Toolbar(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            elevatedToolbar: false
        };
        _this.isElevatedToolbar = false;
        _this.handleScroll = throttle(100, _this.handleScroll.bind(_this));
        return _this;
    }
    Toolbar.prototype.componentDidUpdate = function () {
        var contentDomRef = this.props.contentDomRef;
        var domRef = contentDomRef;
        if (domRef && domRef.current && typeof domRef.current.addEventListener === 'function') {
            domRef.current.addEventListener('scroll', this.handleScroll);
        }
    };
    Toolbar.prototype.componentWillUnmount = function () {
        var contentDomRef = this.props.contentDomRef;
        var domRef = contentDomRef;
        if (domRef && domRef.current && typeof domRef.current.removeEventListener === 'function') {
            domRef.current.removeEventListener('scroll', this.handleScroll);
        }
    };
    Toolbar.prototype.handleScroll = function (event) {
        if (event.target.scrollTop > 0) {
            if (!this.isElevatedToolbar) {
                this.toggleElevatedState(true);
            }
        }
        else {
            this.toggleElevatedState(false);
        }
    };
    Toolbar.prototype.toggleElevatedState = function (isElevated) {
        var _this = this;
        this.setState({
            elevatedToolbar: isElevated
        }, function () {
            _this.isElevatedToolbar = isElevated;
        });
    };
    Toolbar.prototype.render = function () {
        var _a = this.props, className = _a.className, toolbarType = _a.toolbarType, children = _a.children, childClassName = _a.childClassName, navigationContent = _a.navigationContent, toolbarActionContent = _a.toolbarActionContent, toolbarTitle = _a.toolbarTitle, toolbarTitleTag = _a.toolbarTitleTag, toolbarSubtitle = _a.toolbarSubtitle;
        var elevatedToolbar = this.state.elevatedToolbar;
        var containerClassNames = getClassNameList$4(className, toolbarType && UitkToolbarTypes.get(toolbarType) === 'transparent' && 'uitk-toolbar-transparent', {
            elevated: elevatedToolbar,
            'has-placeholder': children
        });
        var Tag = ((toolbarTitleTag && UitkToolbarTitleTags.get(toolbarTitleTag)) ||
            UitkToolbarTitleTags.get('h2'));
        var toolbarTitleContent = toolbarTitle ? (React.createElement(Tag, { className: getClassNameList$4(Toolbar.baseClassName + "-title-content") }, toolbarTitle)) : null;
        var toolbarSubtitleClassname = getClassNameList$4(Toolbar.baseClassName + "-subtitle-content");
        var toolbarSubtitleContent = toolbarSubtitle &&
            (typeof toolbarSubtitle === 'string' ? (React.createElement("p", { className: toolbarSubtitleClassname }, toolbarSubtitle)) : (React.cloneElement(toolbarSubtitle, { className: toolbarSubtitleClassname })));
        var _b = navigationContent || {}, navType = _b.navType, navIconLabel = _b.navIconLabel, navButtonLabel = _b.navButtonLabel, onClick = _b.onClick, onClickAnalytics = _b.onClickAnalytics, navButtonRef = _b.navButtonRef, navButtonId = _b.navButtonId;
        var iconType = ((navType && UitkToolbarNavigationTypeIcons.get(navType)) ||
            UitkToolbarNavigationTypeIcons.get('close'));
        return (React.createElement(UitkToolbarContainer, { className: containerClassNames },
            navigationContent && onClick && (React.createElement(UitkToolbarButton, { onClick: onClick, onClickAnalytics: onClickAnalytics, buttonId: navButtonId, buttonRef: navButtonRef },
                React.createElement(UitkIcon, { id: navButtonId + "-" + iconType + "-toolbar", name: iconType, size: UitkIconSize.MEDIUM, title: navIconLabel }),
                navButtonLabel)),
            React.createElement(UitkLayoutFlexItem, { grow: 1, className: getClassNameList$4('truncate') },
                React.createElement("section", null,
                    toolbarTitleContent,
                    toolbarSubtitle && toolbarSubtitleContent)),
            toolbarActionContent,
            children && (React.createElement(UitkLayoutFlexItem, { className: getClassNameList$4(childClassName), minWidth: "full_width" },
                React.createElement("section", null, children)))));
    };
    Toolbar.displayName = 'UitkToolbar';
    Toolbar.baseClassName = 'uitk-toolbar';
    return Toolbar;
}(React.Component));

var getClassNameList$3 = classNames.bind(styles);
var UitkToolbar = /** @class */ (function (_super) {
    __extends(UitkToolbar, _super);
    function UitkToolbar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UitkToolbar.prototype.render = function () {
        var _a = this.props, elevation = _a.elevation, className = _a.className, props = __rest(_a, ["elevation", "className"]);
        var elevationClassName = '';
        if (elevation === 'flat') {
            elevationClassName = Toolbar.baseClassName + "-" + elevation;
        }
        else if (elevation === 'floating') {
            elevationClassName = "" + elevation;
        }
        var wrapperClassNames = getClassNameList$3(elevationClassName, className);
        return React.createElement(Toolbar, __assign({ className: wrapperClassNames }, props));
    };
    UitkToolbar.displayName = 'UitkStandardToolbar';
    return UitkToolbar;
}(React.Component));

var getClassNameList$2 = classNames.bind(styles);
var UitkToolbarContainer = /** @class */ (function (_super) {
    __extends(UitkToolbarContainer, _super);
    function UitkToolbarContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UitkToolbarContainer.prototype.render = function () {
        var _a = this.props, className = _a.className, children = _a.children, tag = _a.tag;
        // Renders the custom Tag
        var toolbarHeaderTag = ((tag && UitkToolbarContainerTags.get(tag)) ||
            UitkToolbarContainerTags.get('div'));
        var containerClassName = getClassNameList$2('uitk-toolbar', className);
        return (React.createElement(UitkLayoutFlex, { alignItems: "center", className: containerClassName, tag: toolbarHeaderTag }, children));
    };
    UitkToolbarContainer.displayName = 'UitkToolbarContainer';
    UitkToolbarContainer.defaultProps = {
        tag: 'div'
    };
    return UitkToolbarContainer;
}(React.Component));

var getClassNameList$1 = classNames.bind(styles);
var UitkTransparentToolbar = /** @class */ (function (_super) {
    __extends(UitkTransparentToolbar, _super);
    function UitkTransparentToolbar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UitkTransparentToolbar.prototype.render = function () {
        var _a = this.props, overlay = _a.overlay, className = _a.className, props = __rest(_a, ["overlay", "className"]);
        var wrapperClassNames = getClassNameList$1(overlay && Toolbar.baseClassName + "-transparent-overlay", className);
        return React.createElement(Toolbar, __assign({ className: wrapperClassNames }, props, { toolbarType: "transparent" }));
    };
    UitkTransparentToolbar.displayName = 'UitkTransparentToolbar';
    return UitkTransparentToolbar;
}(React.Component));

var getClassNameList = classNames.bind(styles);
var UitkToolbarButton = /** @class */ (function (_super) {
    __extends(UitkToolbarButton, _super);
    function UitkToolbarButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UitkToolbarButton.prototype.render = function () {
        var _a = this.props, disabled = _a.disabled, onClick = _a.onClick, buttonRef = _a.buttonRef, onClickAnalytics = _a.onClickAnalytics, buttonId = _a.buttonId, children = _a.children;
        var analytics = onClickAnalytics && __assign({ localAnalyticsId: 'Close' }, onClickAnalytics);
        var iconContent;
        var buttonLabel;
        // Map through the children and place the ones we want in specific places
        React.Children.forEach(children, function (child) {
            var _a;
            if (!child) {
                return;
            }
            if (((_a = child === null || child === void 0 ? void 0 : child.type) === null || _a === void 0 ? void 0 : _a.displayName) === 'UitkIcon' && !iconContent) {
                iconContent = child;
            }
            else if (typeof child === 'string' && !buttonLabel) {
                buttonLabel = child;
            }
        });
        // Clean up 'v2' extension in class in EGDS graduation hard breaking change
        var baseClass = Toolbar.baseClassName + "-button-v2";
        var contentClass = baseClass + "-content";
        var wrapperClassName = getClassNameList(baseClass, !buttonLabel && baseClass + "-icon-only", buttonLabel && baseClass + "-has-label");
        var contentClassNames = getClassNameList(contentClass, !buttonLabel && contentClass + "-icon-only", buttonLabel && contentClass + "-has-label");
        return (React.createElement(UitkLayoutFlexItem, { className: wrapperClassName, shrink: 0 },
            React.createElement("button", { type: "button", disabled: disabled, onClick: onClick, onClickCapture: analyticsTracker.bind(this, analytics), ref: buttonRef, id: buttonId },
                React.createElement("span", { className: contentClassNames },
                    iconContent,
                    buttonLabel && React.createElement("span", { className: getClassNameList(contentClass + "-label") }, buttonLabel)))));
    };
    UitkToolbarButton.displayName = 'UitkToolbarButton';
    return UitkToolbarButton;
}(React.Component));

export { ToolbarHeaderType, UitkToolbar, UitkToolbarButton, UitkToolbarContainer, UitkTransparentToolbar };
